// extracted by mini-css-extract-plugin
export default {"label":"Label_label__ELdw6","disabled":"Label_disabled__TF+Hl"};